/* CP: open the cart drawer for plain /cart/add forms (product cards + custom product page). */
(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (form.closest('product-form')) return;            // theme component already handles it
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return; // fallback: normal submit
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    var sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
    fd.append('sections', sections.join(','));
    fd.append('sections_url', window.location.pathname);
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { alert(res.description || res.message || 'Could not add to cart.'); return; }
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
        document.dispatchEvent(new CustomEvent('cp:cart-added'));
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });
})();
